import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';

import { WixConnect } from 'shared/utils/wix-connect';

import styles from './tag.styl';


@WixConnect(styles)
export default class Tag extends React.Component {

  static propTypes = {
    text: React.PropTypes.string.isRequired,
    className: React.PropTypes.string,
    roundedClassName: React.PropTypes.string,
    onFocus: React.PropTypes.func,
    onClick: React.PropTypes.func,
    onBlur: React.PropTypes.func,
    rounded: React.PropTypes.bool,
  };

  static defaultProps = {
    onFocus: _.noop,
    onClick: _.noop,
    onBlur: _.noop,
    rounded: false,
  };

  @autobind
  handleClick(event) {
    event.preventDefault();

    const { onClick, text } = this.props;

    onClick(text);
  }

  render() {
    const { text, className, roundedClassName, rounded, onFocus, onBlur } = this.props;

    const styleNames = classnames('tag', {
      rounded,
    });
    const classNames = classnames(className, {
      [roundedClassName]: rounded && roundedClassName,
    });

    return (
      <a href="#"
         styleName={styleNames}
         className={classNames}
         onClick={this.handleClick}
         onFocus={onFocus}
         onBlur={onBlur}>
        <span styleName="inner">
          {text}
        </span>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/tags-cloud/tag/tag.js